<template>
    <div class="row left-content">
        <div class="col-12">
            <h1>Attach payment data to initiate payments</h1>
        </div>
        <div class="col-9">
            <div class="white-block">
                <div class="container">
                    <b-form>
                        <div class="row">
                            <div class="col-12">
                                <label class="mb-0">Card number</label>
                                <b-form-input
                                    v-model="form.number"
                                    type="text"
                                    placeholder="####  ####  ####  ####"
                                    class="mb-2"
                                    v-mask="'####  ####  ####  ####'"
                                ></b-form-input>
                            </div>
                            <div class="col-3">
                                <label class="mb-0">Exp Month</label>
                                <b-form-select
                                    v-model="form.expMonth"
                                    :options="['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']"
                                    class="mb-2"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>##</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                            <div class="col-3">
                                <label class="mb-0">Exp Year</label>
                                <b-form-input
                                    v-model="form.expYear"
                                    type="number"
                                    placeholder="####"
                                    class="mb-2"
                                ></b-form-input>
                            </div>
                            <div class="col-6">
                                <label class="mb-0">CVC</label>
                                <b-form-input
                                    v-model="form.cvc"
                                    type="text"
                                    placeholder="####"
                                    class="mb-2"
                                    v-mask="'####'"
                                ></b-form-input>
                            </div>
                        </div>
                        <b-button variant="primary" type="submit" @click.prevent.stop="create()">Attach</b-button>
                    </b-form>
                    <div class="invalid-feedback d-block" v-for="(error, index) in errors" :key="error">{{ index + ': ' + error }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ServerErrors} from "@/mixins/ServerErrors";
import Swal from "sweetalert2";
import {UrlMixin} from "@/views/admin/Wallet/ProjectWallet/UrlMixin";
export default {
    name: "Payment",
    mixins: [ServerErrors, UrlMixin],
    data() {
        return {
            errors: [],
            form: {
                number: null,
                expMonth: null,
                expYear: null,
                cvc: null,
            }
        }
    },
    methods: {
        create() {
            let loader = this.$loading.show();
            this.errors = [];
            window.axios({
                method: 'POST',
                url: this.getUrl('/admin/wallet/project/customer/set-payment-method'),
                data: {
                    card: {
                        number: this.form.number.replace(/ /gi, ''),
                        expMonth: this.form.expMonth,
                        expYear: this.form.expYear ? parseInt(this.form.expYear) : null,
                        cvc: this.form.cvc,
                    }
                }
            })
                .then(() => {
                    this.$router.push({ name: 'admin.project_wallet.view' });
                })
                .catch(error => {
                    this.errors = this.server_errors;
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.title ? error.response.data.title: "Something went wrong."
                    });
                })
                .finally(() => {
                    loader.hide();
                });
        }
    }
}
</script>